import { mapRecordFromServer, mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetOneResponse, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import { IPricingProfilePartNumber, IPricingProfileValidatePart } from 'pricing/types';

export const getPartNumbers = async (requestPayload: IRequestPayload, signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get(
    `/corporate/discounts/part-fixed-list?${getQueryStringToSnakeCase(requestPayload, {
      excludeKeys: ['sortField', 'sortDir', 'pageSize'],
    })}`,
    signal
  );

  return mapRecordsFromServer<IPricingProfilePartNumber>(data.data, data.recordsFiltered);
};

export const validatePartNumber = async (
  partNumber: string,
  manufacturerId: number,
  includePricing = 1,
  signal?: AbortSignal
): Promise<GetOneResponse<IPricingProfileValidatePart>> => {
  const { data } = await partfinitiClient.get(
    `/corporate/discount-part-fixed/validate-part?${getQueryStringToSnakeCase({
      number: partNumber,
      manufacturerId,
      includePricing,
    })}`,
    signal
  );

  return mapRecordFromServer<IPricingProfileValidatePart>(data);
};

export const upsertPartNumber = async (data) =>
  partfinitiClient.postForm('/corporate/discounts/save-part', data, {
    excludeKeys: [data.uom],
  });

export const removePartNumbers = async (data: { ids: number[] }) =>
  partfinitiClient.postForm('/corporate/discount-part-fixed/remove', data);
